import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';

const AppointmentPaymentCallbackScreen = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const status = searchParams.get('status');
  const transactionId = searchParams.get('transactionId');

  const [countdown, setCountdown] = useState(5);

  const isSuccess = status === 'Success' || status === 'Completed' || status?.toLowerCase() === 'success' || status?.toLowerCase() === 'paid';

  useEffect(() => {
    if (isSuccess) {
      if (countdown > 0) {
        const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        return () => clearTimeout(timer);
      } else {
        navigate('/my-bookings');
      }
    }
  }, [isSuccess, countdown, navigate]);

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col items-center justify-center py-24 px-4 text-center font-sans">
      <div className="max-w-md bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-neutral-200 flex flex-col items-center">
        {isSuccess ? (
          <CheckCircle size={80} className="text-green-500 mb-6" />
        ) : (
          <XCircle size={80} className="text-red-500 mb-6" />
        )}
        
        <h1 className="text-2xl font-bold uppercase tracking-widest mb-4">
          {isSuccess ? 'Payment Successful' : 'Payment Failed'}
        </h1>
        
        <p className="text-neutral-600 mb-8 max-w-sm text-sm">
          {isSuccess 
            ? 'Thank you for your payment. Your appointment booking has been confirmed.'
            : 'Unfortunately, your payment could not be completed. Please try booking again or contact support.'}
        </p>

        {transactionId && (
          <p className="text-xs text-neutral-400 mb-8 uppercase tracking-widest">
            TXN: {transactionId}
          </p>
        )}

        <div className="flex flex-col w-full gap-4">
          <Link 
            to="/my-bookings"
            className="w-full bg-black text-white px-6 py-4 text-xs font-bold tracking-widest uppercase hover:bg-neutral-900 transition-colors text-center rounded-lg"
          >
            {isSuccess ? `View Bookings (${countdown}s)` : 'View Bookings'}
          </Link>
          {!isSuccess && (
            <Link 
              to="/bookings"
              className="w-full bg-white text-black border border-neutral-200 px-6 py-4 text-xs font-bold tracking-widest uppercase hover:bg-neutral-50 hover:border-black transition-colors text-center rounded-lg"
            >
              Book Again
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentPaymentCallbackScreen;
